/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import { get } from 'lodash';
import UIGrid from '../uigrid';
import { isObjectEmpty } from '../../shared/helper';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
// import { saveFormDataInLocalStorage } from '../../shared/feed-common-feature';

import { defaultModalOptions } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';

const CFTable = (props) => {
  const { cfDetails, getSelectedRowDetails, setDisableOkButton, unitopDetails, translateObject, dbTransactionDetails } = props;
  const [rowData] = useState(cfDetails);
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [properties] = useState([
    { hdata: translateObject('Filter'), tag: 'Filter', disabled: true, datatype: 'text', className: 'cf-filter-col' },
    { hdata: 'P_N', tag: 'P_N', disabled: true, datatype: 'text' },
    { hdata: 'TIE', tag: 'TIE', disabled: true, datatype: 'text' },
    { hdata: 'Micron', tag: 'Micron', disabled: true, datatype: 'text' },
    { hdata: translateObject('View Fact Sheet'), tag: 'View', disabled: null, datatype: 'button' },
  ]);
  const handleClick = (e) => {
    // getting all the input tag only where id == input_num -> this will give me input feild in the cf table
    // then getting its id and later pass it to getSelectedRowDetails, which will select & highlight the selected row
    if (e.target.querySelector('input') && e.target.querySelector('input').id.indexOf('input_num') >= 0) {
      const ID = e.target.querySelector('input').id;
      const flag = ID.indexOf('_', 9);
      const row = Number(ID.substring(9, flag)) - 1;
      getSelectedRowDetails(row);
      setDisableOkButton(false);
      localStorage.setItem('globalExitBtn', 'true');
    }
  };

  useEffect(() => {
    for (let i = 0; i < rowData.length; i += 1) {
      $(`#input_num${i + 1}_1`).attr('style', 'overflow: hidden; width: auto');
      if ((i + 1) % 2 === 0)
        $(`.cf-ag-grid-container .row_${i + 1}`).attr('class', `row_${i + 1} row-even`);
      else
        $(`.cf-ag-grid-container .row_${i + 1}`).attr('class', `row_${i + 1} row-odd`);
    }

    // For the default row selection in CF table by Abhishek on 18-Dec-23
    // const defaultCfObj = {
    //   'cf': {
    //     [unitopDetails.id]: {
    //       'Filter': 'RO.Zs 05-40',
    //       'P_N': 1236269,
    //       'TIE': 4,
    //       'Micron': 5,
    //       'Coefficient': 0.01809524,
    //       'DesignFlowPerTIE': 5,
    //       'ViscosityConst': 0.001,
    //       'FactSheetName': '#specfiles\\ROSave.pdf#',
    //       'PassCode': 0,
    //       'flowsheet_link': 'https://estore.watertechnologies.com/document/document/contentdownload/?document_name=FS1097EN.pdf&language=English&security=Public',
    //       'rowIndex': 10
    //     }
    //   }
    // };

    let defObjIndex = 0;
    cfDetails.forEach((item, index) => {
      if (item.Filter === 'RO.Zs 05-40') {
        defObjIndex = index;
      }
    });

    const defObj = cfDetails.find(item => item.Filter === 'RO.Zs 05-40');

    const defaultCfObj = {
      'cf': {
        [unitopDetails.id]: { ...defObj, 'rowIndex': defObjIndex }
      }
    };
    setTimeout(() => {

      // to-do : here by abhi @ 2-apr-25

      const { users_dict } = dbTransactionDetails;
      const curr_user_email = sessionStorage.getItem('user_email');

      const isCfAdmin = users_dict?.[curr_user_email]?.AccountType === 'WF5 Administrator' ?? false;

      let myCfDetails;
      if (!isCfAdmin) {
        myCfDetails = cfDetails.filter(item => item.PassCode === 0).map(item => item.Filter);
        // const savedFile = (JSON.parse(localStorage.getItem('cf-dict')));
      }

      const local = JSON.parse(localStorage.getItem('cf-dict'));
      const temp_cf = get(local, `cf.${unitopDetails.id}`, {});
      if (myCfDetails && myCfDetails.includes(temp_cf.Filter));
      else {
        local.cf[unitopDetails.id] = defaultCfObj.cf[unitopDetails.id];

        // To-Do :  Flag in the UI with some warning msg
        // alert('This file has CF elements for which access is restricted');
      }

      // to-do : here by abhi @ 2-apr-25 end

      // const local = JSON.parse(localStorage.getItem('cf-dict')) || defaultCfObj;

      if (isObjectEmpty(local)) {
        const selected_row = get(local, `cf.${unitopDetails.id}`, {});
        if (Object.keys(selected_row).length > 0) {

          let tempRowInd; // filter the row based on it place in cfDetails array
          cfDetails.forEach((item, index) => {
            if (item.Filter === selected_row.Filter) {
              tempRowInd = index;
            }
          });

          getSelectedRowDetails(tempRowInd);
          // getSelectedRowDetails(selected_row.rowIndex);
          setDisableOkButton(false);
        } else {
          getSelectedRowDetails(defaultCfObj?.cf?.[unitopDetails?.id]?.rowIndex ?? defObjIndex); // hardcoded rowIndex
          // getSelectedRowDetails(defaultCfObj?.cf?.[unitopDetails?.id]?.rowIndex ?? 10); // hardcoded rowIndex
          setDisableOkButton(false);
        }
      }
    }, 10);
  }, [unitopDetails]);

  useEffect(() => {
    document.addEventListener('click', handleClick);
  }, []);

  const handleOnClick = (e) => {
    const ID = e.target.id;
    const flag = ID.indexOf('_', 9);
    const row = Number(ID.substring(9, flag)) - 1;

    if (e.target.type === 'button') {
      const data = rowData[row];

      if (data.flowsheet_link) { // check wheater flowsheet_link is null or not
        window.open(`${data.flowsheet_link}`, '_blank', 'noreferrer');
      }
      else {
        setModalOption({ // show warning
          ...defaultModalOptions,
          visible: true,
          title: 'Warning',
          message: translateObject('Flow Sheet is not available for this Element.'),
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions)
        });
      }
    }
  };

  return (
    <div className='ag-theme-alpine cf-ag-grid-container sansW4SeLig' style={{ overflow: 'auto' }}>
      <Notification
        options={modalOption}
        handleClose={() => setModalOption(defaultModalOptions)}
      />
      <UIGrid
        properties={properties}
        data={rowData}
        onclick={handleOnClick}
      />
    </div>
  );
};

// export default CFTable;
export default React.memo(CFTable);